import React, { useEffect } from 'react';
import { ColorScheme, useBackgroundContext } from '../contexts/BackgroundContext';
import Homepage from './Login/Homepage';

const WelcomePage = () => {
  const backgroundContext = useBackgroundContext();

  useEffect(() => {
    document.title = 'Shine';
    backgroundContext.setScheme({ scheme: ColorScheme.Welcome });
  }, []);

  return <>
    <Homepage/>
  </>;
};

export default WelcomePage;
